import { JWTService } from '@/shared/services/jwt'
// eslint-disable-next-line camelcase
import jwt_decode from 'jwt-decode'

export default function decodeJwt () {
  const token = JWTService.GetToken()
  if (token) {
    try {
      return jwt_decode(token)
    } catch (e) {
      console.error('Erro ao decodificar o token:', e)
    }
  }
  return null
}



// WEBPACK FOOTER //
// ./src/shared/utils/decodeJwt.js